<template>
  <div class="wxs">
    <div class="wxs-icon"><i class="bi bi-cloud-sun"></i></div>
    <div class="wxs-body">
      <div class="wxs-head">{{ $t('demo.weatherSig.head') }}</div>
      <div class="wxs-sub">{{ $t('demo.weatherSig.sub', { store: 'Newell DIY' }) }}</div>
    </div>
    <div class="wxs-drivers">
      <span class="wxs-chip up"><i class="bi bi-thermometer-sun"></i> {{ $t('demo.weatherSig.warmer') }} <b>+9%</b></span>
      <span class="wxs-chip down"><i class="bi bi-cloud-rain"></i> {{ $t('demo.weatherSig.rain') }} <b>−6%</b></span>
    </div>
    <a class="wxs-link" href="#" @click.prevent="$emit('open')">
      {{ $t('demo.weatherSig.fullPicture') }} <i class="bi bi-arrow-right-short"></i>
    </a>
  </div>
</template>

<script setup>
// Compact Intelligence tile — the store's weather SIGNATURE (the "why"), pointing
// to the full Explore deep-dive. Demo copy; real version reads the engine.
defineEmits(['open'])
</script>

<style scoped>
.wxs {
  display: flex;
  align-items: center;
  gap: 14px;
  background: linear-gradient(90deg, #ecf8f7, #f5faf2);
  border: 1px solid #d9ece9;
  border-left: 3px solid #1f9d9d;
  border-radius: 12px;
  padding: 0.7rem 1rem;
  margin: 0 0 18px;
}
.wxs-icon {
  flex: 0 0 auto;
  width: 38px; height: 38px;
  border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  background: #fff; color: #178f8f; font-size: 1.1rem;
  box-shadow: 0 1px 3px rgba(20, 60, 55, 0.08);
}
.wxs-body { flex: 1 1 auto; min-width: 0; }
.wxs-head { font-weight: 650; color: #12615f; font-size: 0.95rem; }
.wxs-sub { font-size: 0.82rem; color: #4a6b68; margin-top: 1px; }
.wxs-drivers { flex: 0 0 auto; display: flex; gap: 7px; }
.wxs-chip {
  display: inline-flex; align-items: center; gap: 4px;
  font-size: 0.8rem; padding: 3px 9px; border-radius: 999px;
  background: #fff; border: 1px solid #dfeeeb;
}
.wxs-chip b { font-weight: 700; }
.wxs-chip.up { color: #2f7d4f; }
.wxs-chip.down { color: #9a6a1c; }
.wxs-link {
  flex: 0 0 auto;
  display: inline-flex; align-items: center; gap: 0.15rem;
  font-size: 0.82rem; font-weight: 600; white-space: nowrap;
  color: #147c7c; text-decoration: none;
}
.wxs-link:hover { text-decoration: underline; }
.wxs-link i { font-size: 1rem; }

@media (max-width: 900px) {
  .wxs { flex-wrap: wrap; }
  .wxs-body { flex: 1 1 100%; order: 1; }
  .wxs-icon { order: 0; }
  .wxs-drivers, .wxs-link { order: 2; }
}
</style>
